import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { isLimitedRole } from "./lib/apiClient";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import OrdersPage from "./pages/OrdersPage";
import OrderNewPage from "./pages/OrderNewPage";
import OrderDetailPage from "./pages/OrderDetailPage";
import LabelsPage from "./pages/LabelsPage";
import ScanPage from "./pages/ScanPage";
import ShipmentsPage from "./pages/ShipmentsPage";
import ShipmentNewPage from "./pages/ShipmentNewPage";
import ShipmentDetailPage from "./pages/ShipmentDetailPage";
import ShipmentPanelPage from "./pages/ShipmentPanelPage";
import ShipmentListPrintPage from "./pages/ShipmentListPrintPage";
import ProductionPage from "./pages/ProductionPage";
import UsersPage from "./pages/UsersPage";
import HistoryPage from "./pages/HistoryPage";
import FabricsPage from "./pages/FabricsPage";
import SizesPage from "./pages/SizesPage";
import ProductionListPage from "./pages/ProductionListPage";
import ProductionListPrintPage from "./pages/ProductionListPrintPage";
import OrderStatusPanelPage from "./pages/OrderStatusPanelPage";
import QualityControlPage from "./pages/QualityControlPage";
import ReportsPage from "./pages/ReportsPage";
import OperatorHomePage from "./pages/OperatorHomePage";
import PieceRulesPage from "./pages/PieceRulesPage";
import ApiKeysPage from "./pages/ApiKeysPage";
import InstallPWA from "./components/InstallPWA";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 font-mono">Yükleniyor...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" replace />;
  return children;
}

// Sınırlı rolleri (yatak_paketleme, terzihane_yatak, terzihane1, baza_uretim, kontrol_operator, baslik_doseme)
// tüm URL'lerden /operator ekranına yönlendirir
function LimitedRoleGate({ children }) {
  const { user } = useAuth();
  if (user && isLimitedRole(user.role)) {
    return <Navigate to="/operator" replace />;
  }
  return children;
}

function OperatorOnly({ children }) {
  const { user } = useAuth();
  if (user && !isLimitedRole(user.role)) {
    // Normal roller /operator'a girmesin — dashboard'a dön
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/giris" element={<LoginPage />} />

            {/* Sınırlı operatör ana ekranı — sidebar yok */}
            <Route
              path="/operator"
              element={
                <Protected>
                  <OperatorOnly>
                    <OperatorHomePage />
                  </OperatorOnly>
                </Protected>
              }
            />

            <Route
              path="/"
              element={
                <Protected>
                  <LimitedRoleGate>
                    <Layout />
                  </LimitedRoleGate>
                </Protected>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="siparisler" element={<OrdersPage />} />
              <Route path="siparisler/yeni" element={<OrderNewPage />} />
              <Route path="siparisler/:id" element={<OrderDetailPage />} />
              <Route path="uretim-listesi" element={<ProductionListPage />} />
              <Route path="uretim-listesi/yazdir" element={<ProductionListPrintPage />} />
              <Route path="panel" element={<OrderStatusPanelPage />} />
              <Route path="etiketler" element={<LabelsPage />} />
              <Route path="tara" element={<ScanPage />} />
              <Route path="uretim" element={<ProductionPage />} />
              <Route path="kalite" element={<QualityControlPage />} />
              <Route path="raporlar" element={<ReportsPage />} />
              <Route path="sevkiyatlar" element={<ShipmentsPage />} />
              <Route path="sevkiyatlar/yeni" element={<ShipmentNewPage />} />
              <Route path="sevkiyatlar/:id" element={<ShipmentDetailPage />} />
              <Route path="sevkiyat-paneli" element={<ShipmentPanelPage />} />
              <Route path="sevkiyat-paneli/:id" element={<ShipmentPanelPage />} />
              <Route path="sevkiyat-listesi/yazdir" element={<ShipmentListPrintPage />} />
              <Route path="kullanicilar" element={<UsersPage />} />
              <Route path="kumaslar" element={<FabricsPage />} />
              <Route path="olculer" element={<SizesPage />} />
              <Route path="kurallar" element={<PieceRulesPage />} />
              <Route path="api-anahtarlari" element={<ApiKeysPage />} />
              <Route path="gecmis" element={<HistoryPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <InstallPWA />
      </AuthProvider>
    </div>
  );
}

export default App;
